import { render, staticRenderFns } from "./dataTopNav.vue?vue&type=template&id=08c755bb&scoped=true&"
import script from "./dataTopNav.vue?vue&type=script&lang=js&"
export * from "./dataTopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c755bb",
  null
  
)

export default component.exports